<template>
    <!-- 会员管理－补开卡页面 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'repairCard')">
            <div slot="header">
                <div class="text-right">
                    <a-button type="primary" @click="toRepairCardList">手动补开卡信息管理</a-button>
                    <a-button type="primary" @click="toBatchManage">批量导入管理</a-button>
                    <a-button type="primary" @click="downloadExcal">导入模板下载</a-button>
                </div>
            </div>
            <div class="wrap-container-in" v-if="shopId != -1">
                <a-form :form="form" class="ticket-one-form">
                    <a-form-item label="会员手机号" :labelCol="{span: 8}" :wrapperCol="{span: 10}">
                        <a-input
                            placeholder="请输入"
                            v-decorator="['phone',{rules: [{required: true, message: '请输入会员手机号'},{pattern: /^\d{11}$/, message: '请输入正确的手机号'}]}]"
                        ></a-input>
                    </a-form-item>
                    <a-form-item label="票券名称" :labelCol="{span: 8}" :wrapperCol="{span: 10}">
                        <a v-if="!ticket.ticketTemplateId" class="text-primary ml8" @click="openTicketSelect">选择票券</a>
                        <section class="flex flex-start" v-else>
                            <!-- <a-select
                                style="width: 90%"
                                :showArrow="false"
                                disabled
                                placeholder="请选择"
                                v-decorator="['ticketTemplateId', {initialValue: ticket.ticketTemplateId, rules: [{required: true, message: '请输入票券名称',}]}]"
                            >
                                <a-select-option
                                    :value="item.ticketTemplateId"
                                    v-for="item in ticketList"
                                    :key="item.ticketTemplateId"
                                >{{item.name}}</a-select-option>
                            </a-select> -->
                            <div class="gooods-length">{{ticket.name}}</div>
                            <a-input class="hideInput" disabled v-decorator="['ticketTemplateId', {initialValue: ticket.ticketTemplateId, rules: [{required: true, message: '请输入票券名称',}]}]"></a-input>
                            <a class="text-primary ml8 text-right" @click="openTicketSelect">修改</a>
                        </section>
                    </a-form-item>
                    <a-form-item label="开卡数量" :labelCol="{span: 8}" :wrapperCol="{span: 10}">
                        <a-input-number
                            style="width:100%"
                            :min="1"
                            :precision="0"
                            placeholder="请输入正整数"
                            v-decorator="['grantNum',{rules: [{required: true, message: '请输入开卡数量',}]}]"
                        />
                    </a-form-item>
                    <a-form-item
                        label="有效期限"
                        :labelCol="{span: 8}"
                        :wrapperCol="{span: 10}"
                    >
                        <a-range-picker
                            style="width:100%"
                            v-decorator="['validDate',{rules: [{required: true, message: '请输入有效期限',}]}]"
                        />
                    </a-form-item>
                    <a-form-item
                        label="来源区分"
                        :labelCol="{span: 8}"
                        :wrapperCol="{span: 10}">
                        <a-radio-group v-decorator="['isThird',{initialValue:true}]">
                            <a-radio :value="true">第三方购买</a-radio>
                            <a-radio :value="false">票券赠送</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item
                        label="是否发送短信"
                        :labelCol="{span: 8}"
                        :wrapperCol="{span: 10}">
                        <a-radio-group v-decorator="['isSendMessage',{initialValue:false}]">
                            <a-radio :value="true">是</a-radio>
                            <a-radio :value="false">否</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <remark :labelSpan="8" :wrapperSpan="10" operateCode="RepairTicket" />
                    <section v-show="Boolean(ticketGiveDetail.gifts.length)">
                        <a-divider></a-divider>
                        <div class="menber-give-info-container">
                            <div class="mb8">
                                <span class="font-bigger text-color-85">新票赠品信息</span>
                                <span class="text-primary ml24">该商品正处于活动“{{ticketGiveDetail.name}}”期间，是否赠送对应赠品？</span>
                            </div>
                            <a-spin :spinning="spinning">
                                <member-order-give-selector :isNewActivity="true" :ticketGiftDetail="ticketGiveDetail" type="repairCard" ref="targetGiveSelector"></member-order-give-selector>
                            </a-spin>
                        </div>
                    </section>
                    <a-form-item class="text-center">
                        <a-button
                            v-if="getBtnByAuth('setMessage')"
                            type="primary"
                            @click="showConfirm"
                            :loading="confirmLoading"
                        >确认</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-empty class="pt24 pb24" v-else >
                <span slot="description" class="font-big22">请切换到各门店查看</span>
            </a-empty>
            <!-- 操作2次确认 -->
            <a-modal
            centered
            :maskClosable="false"
            :destroyOnClose="true"
            title="补开卡"
            :visible="visibleConfirm2"
            @cancel="visibleConfirm2 = false"
            :width="600"
            >
                <div class="text-center font-bigger text-color-85 mb16">{{ticket.showName || ticket.ticketName}}</div>
                <div class="text-primary mb16">活动商品确认：</div>
                <a-table
                bordered
                :columns="columns"
                :rowKey="(item, index) => index"
                :dataSource="confirmDataSource"
                :pagination="false"
                :scroll="{y: 250}"
                >
                    <template slot="type" slot-scope="key">
                        {{["", "票券", "优惠券", "储值卡", "积分"][key]}}
                    </template>
                </a-table>
                <template slot="footer">
                    <a-button @click="visibleConfirm2 = false">取消</a-button>
                    <a-button type="primary" :loading="confirmLoading" @click="handleSubmit">确定</a-button>
                </template>
            </a-modal>
        </content-view>
        <ticket-picker tableType="radio" goodType="ticket" ref="ticketPicker" :ticketList="ticketList" @confirmSelectTicket='confirmSelectTicket'></ticket-picker>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from 'moment';
    import { mapGetters } from "vuex";
    import memberOrderGiveSelector from '@/components/modules/order/member-order-give-selector.component';
    import remark from '@/components/modules/platform/remark.component';
    import ticketPicker from "@/components/modules/platform/tickets-picker.component"
    let columns = [
        {
            title: '赠送商品名称',
            dataIndex: 'goodsName',
        },
        {
            title: '赠送商品类型',
            dataIndex: 'type',
            scopedSlots: { customRender: "type" },
            width: 100
        },
        {
            title: '赠送数量',
            dataIndex: 'number',
            width: 100
        }
    ];
    export default {
        name: 'memberUser',
        components: {
            memberOrderGiveSelector,
            remark,
            ticketPicker,
        },
        props: {},
        data() {
            return {
                columns,
                ticketList: [],
                maxUse: 1,
                ticket: {},
                ticketGiveDetail: {gifts: []},
                spinning: false,
                visibleConfirm2: false,
                confirmLoading: false,
                confirmDataSource: [],
                remarkList: [],
                grantGiveActivityDetails: [],
            };
        },
        computed: {
            ...mapGetters(["shopId", "shopName"])
        },
        watch: {
            shopId() {
                this.getTicketList();
            }
        },
        methods: {
            openTicketSelect() {
                this.$refs.ticketPicker.visible = true;
            },
            /**
             * @showConfirm 赠品确认
             */
            showConfirm() {
                this.form.validateFields((err, values) => {
                    if (err) {
                        return false;
                    }
                    this.confirmDataSource = [];
                    this.grantGiveActivityDetails = [];
                    let grantGiveActivityDetails = [];
                    let { targetGiveSelector } = this.$refs;
                    if (Boolean(targetGiveSelector) && this.ticketGiveDetail && this.ticketGiveDetail.gifts.length) {
                        grantGiveActivityDetails.push({
                            operateNum: values.grantNum,
                            ticketTemplateId: values.ticketTemplateId,
                            operateObjectCategory: "TICKET",
                            isMainGoods: true,
                        })
                        targetGiveSelector.getSelectedRows().forEach( el => {
                            switch (el.type) {
                                case 1:
                                    grantGiveActivityDetails.push({
                                        operateNum: el.number,
                                        ticketTemplateId: el.giveId,
                                        operateObjectCategory: "TICKET",
                                    })
                                    break;
                                case 2:
                                    grantGiveActivityDetails.push({
                                        operateNum: el.number,
                                        operateObjectCategory: "COUPON",
                                        couponTemplateId: el.giveId,
                                    })
                                    break;
                                case 3:
                                    grantGiveActivityDetails.push({
                                        operateNum: el.number,
                                        balanceCardId: el.giveId,
                                        operateObjectCategory: "BALANCE",
                                    })
                                    break;
                                case 4:
                                    grantGiveActivityDetails.push({
                                        operateObjectCategory: "POINT",
                                        pointNum: el.number,
                                    })
                                    break;
                                default:
                                    break;
                            }
                        })
                        this.confirmDataSource = targetGiveSelector.getSelectedRows();
                        this.grantGiveActivityDetails = grantGiveActivityDetails;
                    } else {
                    }
                    if (!Boolean(targetGiveSelector) || !Boolean(this.confirmDataSource.length)) {
                        this.handleSubmit();
                        return false;
                    }
                    this.visibleConfirm2 = true;
                });
            },
            handleSubmit() {
                if (!this.ticket.ticketTemplateId) {
                    this.$message.warning("请先选择票券");
                    return;
                }
                this.form.validateFields((err, values) => {
                    if (!err) {
                        const validDate = values.validDate;
                        let validStartTime = validDate ? this.$moment(validDate[0]).format('YYYY-MM-DD 00:00:00') : undefined
                        let validEndTime = validDate ? this.$moment(validDate[1]).format('YYYY-MM-DD 23:59:59') : undefined
                        delete values.validDate;
                        let value = {
                            ...values,
                            grantGoodsType: this.grantGiveActivityDetails.length ? "ACTIVITY" : "TICKET",
                            goodsTemplateId: this.grantGiveActivityDetails.length ? this.ticketGiveDetail.id : values.ticketTemplateId,
                            validStartTime,
                            validEndTime,
                            phone: values.phone.toString().trim(),
                            shopId: this.shopId,
                            shopName: this.shopName,
                        };
                        if (this.grantGiveActivityDetails.length > 0) {
                            value.grantGiveActivityDetails = this.grantGiveActivityDetails;
                        }
                        this.confirmLoading = true;
                        this.subApi(value)
                    }
                });
            },
            subApi(value) {
                this.$api.member.repairOrder({
                    body: value
                }).then(res => {
                    this.form.resetFields();
                    this.$message.success('操作成功，已开卡数量 ' + value.grantNum);
                    this.confirmLoading = false;
                    this.visibleConfirm2 = false;
                    this.confirmDataSource = [];
                    this.ticket = {};
                    this.ticketGiveDetail = {gifts: []};
                }).catch(err => {
                    this.confirmLoading = false;
                });
            },
            disabledDate(current) {
                return (
                    current &&
                    current < moment(this.ticket.validStartDate) ||
                    current > moment(this.ticket.validEndDate)
                );
            },
            confirmSelectTicket(ticket) {
                if (!ticket || !ticket.length) {
                    this.$message.warning("请先选择票券");
                    return;
                }
                this.ticket = ticket[0];
                if (this.ticket.validTimeSetMode == 1) {
                    var validStartDate = this.$moment().format("YYYY-MM-DD")
                    var validEndDate = this.$moment().add(this.ticket.validTimeSetParam, 'days').format("YYYY-MM-DD")
                } else if (this.ticket.validTimeSetMode == 2) {
                    var validStartDate = this.ticket.validTimeSetParam.split("~")[0].substring(0, 10)
                    var validEndDate = this.ticket.validTimeSetParam.split("~")[1].substring(0, 10)
                }
                const validDate = [
                    moment(validStartDate, 'YYYY-MM-DD'),
                    moment(validEndDate, 'YYYY-MM-DD')
                ];
                this.form.setFieldsValue({
                    validDate: validDate
                });
                this.getTicketGiveInfoVo();
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            getTicketList() {
                if(!this.shopId) return
                this.$api.totalPlatform.getTotalTicketList({
                    body: {
                        // isMiniSell: true,
                        sellShopId: this.shopId
                    }
                }).then(res => {
                    res.forEach(el => {
                        el.goodsType = 1;
                        el.value = el.ticketTemplateId;
                    })
                    this.ticketList = res;
                });
            },
            downloadExcal() {
                this.$api.member.templateUrl({},
                    {
                        responseType: "blob"
                    }
                ).then( res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });

                    this.downloadUrl = window.URL.createObjectURL(blob);

                    let name = this.$route.meta.name + '-' + this.$moment().format('YYYYMMDD') + '.xls'

                    a.setAttribute("href", this.downloadUrl);

                    var reportName = decodeURI(name);

                    a.setAttribute("download", reportName);
                    a.click();
                })
            },
            toRepairCardList() {
                this.$router.push({ name: 'repairCardList' });
            },
            toBatchManage() {
                this.$router.push({ name: 'batchManage' });
            },
            /**
             * @getTicketGiveInfoVo 获取目标票券赠品的信息
             */
            getTicketGiveInfoVo() {
                this.spinning = true;
                if (Boolean(this.$refs.targetGiveSelector)) {
                    this.$refs.targetGiveSelector.selectedRows = [];
                    this.$refs.targetGiveSelector.selectedRowKeys = [];
                }
                this.$api.member.getTicketGiveInfoVoByTicketId({
                    params: {
                        ticketId: this.ticket.ticketTemplateId
                    }
                }).then(res => {
                    this.spinning = false;
                    if (!res) {
                        this.ticketGiveDetail = {gifts: []}
                        return;
                    }
                    res.gifts.forEach(item => {
                        item.goodsName = item.showName || item.name;
                    })
                    let obj = {};
                    //pointType 1不送积分，2固定，3订单金额倍数积分
                    switch(res.pointType) {
                        case 2:
                            obj.goodsName = '积分';
                            obj.type = 4;
                            obj.number = res.pointNum;
                            res.gifts.push(obj);
                            break;
                    }
                    this.ticketGiveDetail = res;
                });
            }
        },
        created() {},
        mounted() {
            this.getTicketList();
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        }
    };
</script>
<style lang="scss">
.menber-give-info-container {
    background-color: #f3f3f3;
    padding: 14px;
    width: 600px;
    margin: 0 auto 24px auto;
}
.hideInput {
    visibility: hidden;
    width: 0;
    height: 0;
    overflow: hidden;
    padding: 0;
    border: none
}
.gooods-length {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
